
import Vue from "vue";
import AppLedgerAccountBrowse from "@/components/ledger-accounts/LedgerAccountBrowse.vue";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	created(){
		if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppLedgerAccountBrowse
	}
});
